import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";

export function usePartnership(partnershipId: Nullable<string>) {
	/** Hooks */
	const { organization } = useAuth();
	const query = useQuery({
		queryKey: ["partnerships", partnershipId ?? ""],
		queryFn: async () => {
			if (!organization?.id) throw Error;
			if (!partnershipId) throw Error;
			const response = await client.organizations[":orgId"].partnerships[":partnershipId"].$get({
				param: {
					orgId: organization?.id,
					partnershipId,
				},
			});
			const data = await responseHandler(response);
			return data.partnership;
		},
		enabled: !!partnershipId,
	});

	return { ...query, partnership: query.data };
}
